import { __extends } from "tslib";
import { StartFaceSearchRequest, StartFaceSearchResponse } from "../models/index";
import { deserializeAws_json1_1StartFaceSearchCommand, serializeAws_json1_1StartFaceSearchCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartFaceSearchCommand = /** @class */ (function (_super) {
    __extends(StartFaceSearchCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartFaceSearchCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartFaceSearchCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: StartFaceSearchRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartFaceSearchResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartFaceSearchCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartFaceSearchCommand(input, context);
    };
    StartFaceSearchCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartFaceSearchCommand(output, context);
    };
    return StartFaceSearchCommand;
}($Command));
export { StartFaceSearchCommand };
//# sourceMappingURL=StartFaceSearchCommand.js.map